import { CountryCell, TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { column } from "app/components/React/Table/SWReactTableDefaults";
import { translate } from "app/filters/i18nFilter";

export const getBacklinksCountriesTableColumns = () => [
    column({
        field: "CountryID",
        sortable: false,
        displayName: translate("wwo.geography.table.country.header"),
        headerComponent: DefaultCellHeader,
        cellComponent: CountryCell,
    }),
    column({
        field: "RefDomainsShare",
        displayName: translate("digitalsuite.backlinks.overview.countries.refDomainsShare"),
        type: "double",
        format: "percentagesign",
        sortable: false,
        isSorted: false,
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeader,
        sortDirection: "desc",
    }),
];
